import React, { type ReactNode } from 'react'

import { RemoveModificationButton } from '../RemoveModificationButton/RemoveModificationButton'
import * as S from './ProductItemSummary.styled'

export type ProductItemSummaryProps = {
  label: ReactNode
  onRemoveModificationClick: () => void
}

export const ProductItemSummary = ({
  label,
  onRemoveModificationClick,
}: ProductItemSummaryProps) => {
  return (
    <S.Container>
      <S.Item>
        {label}
        <RemoveModificationButton
          ariaLabel="Remove promo code"
          onClick={onRemoveModificationClick}
        />
      </S.Item>
    </S.Container>
  )
}
